export default __webpack_public_path__ + "static/media/1966.190b82cd.png";